import Backend from "./Backend";
import {selectedCompanyStore} from "../store/SelectedCompany";
import DriveFile from "../model/file/DriveFile";
import {EmailTemplateDto, SendAccountantEmailDto} from "../model/EmailTemplates";

class EmailTemplateApi {

    public getEmailTemplates(): Promise<DriveFile[]> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.get(`/api/v1/company/${companyId}/templates/accountant/emails`);
    }

    public openEmailTemplate(fileId: string): Promise<EmailTemplateDto> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.get(`/api/v1/company/${companyId}/templates/accountant/emails/${fileId}/open`);
    }

    public openDefaults(): Promise<EmailTemplateDto> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.get(`/api/v1/company/${companyId}/templates/accountant/emails/defaults`);
    }

    public sendEmailToClient(email: SendAccountantEmailDto): Promise<void> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.post(`/api/v1/company/${companyId}/templates/accountant/emails/send`, email);
    }
}

export const emailTemplateApi = new EmailTemplateApi();